<template>
  <div itemscope itemtype="http://schema.org/PropertyValue" class="family-and-icon">
    <div class="icon">
      <template v-if="subfamily">
        <div class="outer" :style="{background: family.color}" />
        <div class="inner" :style="{background: subfamily ? subfamily.color:family.color}" />
      </template>
      <template v-else>
        <div class="inner" :style="{background: family.color}" />
      </template>
    </div>
    <meta itemprop="name" content="family">
    <!-- <div itemprop="value" class="label" v-tooltip.top="label">{{label}}</div> -->
    <div itemprop="value" class="label">{{ label }}</div>
  </div>
</template>

<script>
import {VTooltip} from 'v-tooltip'
export default {
  name: 'FamilyWithIcon',
  components:{
  },
  directives:{
    tooltip: VTooltip
  },
  props: ['family','subfamily'],
  computed:{
    label (){
      if(this.family.name){
        if(this.subfamily)
          return this.family.name + ' / ' + this.subfamily.name
        return this.family.name
      } else
        return ''
    }
  },
  methods:{
  }
}
</script>

<style scoped lang="stylus">
.family-and-icon
  align-items: center
  display: flex

  .icon
    // added 2 extra pixels for deciaml cutting
    height: vw(20px)
    margin-right: vw(5px)
    position: relative
    width: @height

    .mobile &
      margin-right: vw(5px)

    .outer,
    .inner
      left: 50%
      position: absolute
      top: 50%
      transform: translate(-50%, -50%)

    .outer
      border-radius: 50%
      height: vw(18px)
      width: @height

      .mobile &
        height: vw(15px)
        width: @height

    .inner
      border: solid 1px rgba(255, 255, 255, 1)
      border-radius: 50%
      height: vw(10px)
      width: @height

      &:only-child
        height: vw(15px)
        width: @height

        .mobile &
          height: vw(15px)
          width: @height

      .mobile &
        height: vw(7px)
        width: @height

  .label
    align-items: center
    flex: 1 1 0%
    m-ellipsis(100%)
    m-font-size(12, 16)
    margin-top: 0.25em

    .mobile &
      m-font-size(11, 14)
</style>